import { arrayToBase64, base64ToArray, deriveAesSecretKey, generateRandomSalt, } from '@lucidlink/ts-crypto/crypto';
import { webCrypto } from '@lucidlink/ts-crypto/web-crypto';
export class AccountCrypto {
    crypto;
    constructor(crypto) {
        this.crypto = crypto;
    }
    accountKey;
    async getAccountKey() {
        if (!this.accountKey) {
            this.accountKey = await decryptAccountKey(this.crypto.eAccountKey, this.crypto.wrappingKey);
        }
        return this.accountKey;
    }
}
export const decryptAccountKey = async (eCryptoKey, wrappingKey) => {
    const eKeyBuffer = new Uint8Array(base64ToArray(eCryptoKey));
    const unwrappedCryptoKey = await webCrypto.subtle.unwrapKey('raw', eKeyBuffer, wrappingKey, 'AES-KW', 'AES-GCM', true, ['encrypt', 'decrypt']);
    return unwrappedCryptoKey;
};
export const wrapKeyWithAesKey = async (aesSecret, cryptoKey) => {
    const cryptoSalt = generateRandomSalt();
    const aesSecretKey = await deriveAesSecretKey(aesSecret, cryptoSalt);
    const wrappedCryptoKey = await webCrypto.subtle.wrapKey('raw', cryptoKey, aesSecretKey, { name: 'AES-KW' });
    const encodedCryptoKey = arrayToBase64(wrappedCryptoKey);
    return {
        wrappedCryptoKeyB64: encodedCryptoKey,
        salt: cryptoSalt,
    };
};
export const wrapAesKeyWithAesKey = async (cryptoKey, wrappingAesKey) => {
    const wrappedCryptoKey = await webCrypto.subtle.wrapKey('raw', cryptoKey, wrappingAesKey, { name: 'AES-KW' });
    return arrayToBase64(wrappedCryptoKey);
};
